import { memo } from 'react';
import { useDispatch } from 'react-redux';
import { useDeepCompareEffect } from 'react-use';

import { loadBackOfficeEnterprises } from 'store/modules/backOfficeEnterprises/actions';

import { useBackOfficeEnterprisesRequestParameters } from '../useBackOfficeRequestParameters';

type Props = {
  isReady: boolean
};

function BackOfficeEnterprisesRequest({ isReady }: Props): null {
  const parameters = useBackOfficeEnterprisesRequestParameters();
  const dispatch = useDispatch();

  useDeepCompareEffect(() => {
    if (isReady) {
      dispatch(loadBackOfficeEnterprises(parameters));
    }
  }, [dispatch, parameters, isReady]);

  return null;
}

export default memo(BackOfficeEnterprisesRequest);
